import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * LeaderboardRowSkeleton - Loading skeleton for LeaderboardRow
 * Matches the structure of LeaderboardRow with pulse animation
 */
export const LeaderboardRowSkeleton: React.FC = () => {
  return (
    <div
      className="flex items-center justify-between p-4 rounded-xl bg-game-card"
      data-test-id="leaderboard-row-skeleton"
    >
      <div className="flex items-center gap-4">
        {/* Rank badge skeleton */}
        <Skeleton className="w-8 h-8 rounded-lg" />

        {/* Username skeleton */}
        <Skeleton className="w-32 h-5" />
      </div>

      {/* Points skeleton */}
      <Skeleton className="w-12 h-6" />
    </div>
  );
};

export default LeaderboardRowSkeleton;
